import { Link } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";
import { motion } from "motion/react";

export default function FlashDealsCTA({ content }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="flex justify-center py-16 sm:py-20"
    >
      <motion.div whileHover={{ y: -3 }} whileTap={{ scale: 0.97 }}>
        <Link
          href={content.href}
          className="inline-flex min-h-14 items-center justify-center gap-3 rounded-full bg-neutral-950 px-8 py-4 text-sm font-black uppercase text-white shadow-xl shadow-black/15 transition hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2"
        >
          {content.label}
          <ArrowRight className="size-5" />
        </Link>
      </motion.div>
    </motion.div>
  );
}